export type PoolSource = 'override' | 'env' | 'fallback';

type SourceCopy = { label: string; title: string };

const DEFAULT_COPY: Record<PoolSource, SourceCopy> = {
  override: { label: 'Override', title: 'Per-org override is in effect.' },
  env: {
    label: 'Env default',
    title: 'Inherited from AMBER_AGGREGATION_MIN_POOL_DEFAULT env var.',
  },
  fallback: { label: 'Fallback', title: 'Hard-coded fallback (no env var set).' },
};

// Shared by the BesideU-Admin org-settings editor (`AdminOrgDetail.tsx`) and
// the HR-facing read-only privacy card (`HrSettings.tsx`) — both show the
// same amber-aggregation-pool `override`/`env`/`fallback` resolution tier,
// via `resolveAmberAggregationMinPoolDetailed`. Single source of truth for
// styling and the source-to-tone mapping, so the two surfaces can't drift;
// `copy` lets each surface use audience-appropriate wording (defaults to the
// operator-facing copy) without duplicating the badge markup itself.
export function PoolSourceBadge({
  source,
  copy = DEFAULT_COPY,
}: {
  source: PoolSource;
  copy?: Record<PoolSource, SourceCopy>;
}) {
  const { label, title } = copy[source];
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-[10px] font-medium tracking-normal uppercase ${
        source === 'override'
          ? 'bg-traffic-amber/10 text-traffic-amber-text'
          : 'bg-muted text-muted-foreground'
      }`}
      title={title}
    >
      {label}
    </span>
  );
}
